export const defaultAction = (dispatch, data) => {
    dispatch({
        type: "UPDATE_PIC_",
        payload: data
    })
}